angular.module('unergie.main')
.controller('contractActivationModalCtrl', ($scope, $sce, $filter, $uibModalInstance, $q, ApiUser, CommonRegex, DataAccess, Tokens, OrganizationService, PrmValuesValidatorService,
    contract, ReferencesService, BoFeaturesService, PrmUtilsService, AlertManager, AdminComments, MetaWatcher, ErrorCatcher, AuthService, createJira, ContractConstants, EnvUtils) => {
    $scope.contract = contract
    $scope.activationTelesellerMode = BoFeaturesService.isFeatureOn('activationTelesellerMode')
    $scope.canManualActivation = BoFeaturesService.isFeatureOn('canManualActivation')
    $scope.canModifySubscriptionType = BoFeaturesService.isFeatureOn('canModifySubscriptionType')
    $scope.canAddC2C4 = BoFeaturesService.isFeatureOn('canAddC2C4')

    $scope.isLinkyN2 = () => PrmUtilsService.isLinkyN2($scope.contract.prm)
    $scope.maxDays = PrmUtilsService.getMaxDaysForPRMIntervention($scope.contract.prm)
    $scope.proMode = contract.account && contract.account.category === 'pro'
    $scope.smallBusinessMode = contract.account && contract.account.category === 'small-business'

    if ($scope.proMode) {
        OrganizationService.handlesServiceOrders(contract.account.organization).then((handlesServiceOrders) => {
            $scope.canBypassServiceOrder = handlesServiceOrders && BoFeaturesService.isFeatureOn('canBypassServiceOrder')
        })
    }

    const hotlineNumber = BoFeaturesService.get('hotlineNumber')
    $scope.showTools = !BoFeaturesService.get('isEnvProd')

    const providerActionNeededText = `${'Une mise en service en urgence nécessite un traitement immédiat par le service client Plüm énergie :' +
        '<ul><li>tenter un transfert accompagné vers le service client Plüm</li>' +
        '<li>en cas d\'injoignabilité, donner le numéro au client et lui dire d\'appeler au plus vite ('}${hotlineNumber})</li></ul>`
    $scope.providerActionNeededText = $sce.trustAsHtml(providerActionNeededText)
    $scope.canFlagActivationInJira = BoFeaturesService.isFeatureOn('canFlagActivationInJira')
    $scope.canSeeActivationMessages = BoFeaturesService.isFeatureOn('canSeeActivationMessages')
    $scope.prices = {}

    $scope.isC5 = !['C2', 'C3', 'C4', 'INDET_C2_C3'].includes($scope.contract.segment)

    $scope.crMode = !$scope.isC5 && !$scope.canAddC2C4

    $scope.switchActivationMode = () => {
        $scope.crMode = !$scope.crMode
    }

    $scope.nameRegex = CommonRegex.fullname
    $scope.phoneRegex = CommonRegex.phone.french
    $scope.contactDeployed = false
    $scope.readingsDeployed = false
    $scope.hasRetriedActivation = false

    $scope.urgenceText = undefined

    $scope.urgences = ContractConstants.urgencesList

    $scope.urgencesCDFInter = ContractConstants.urgencesCDFInter

    $scope.urgencesComLinky = ContractConstants.urgencesComLinky

    $scope.urgencesFirstMES = ContractConstants.urgencesFirstMES

    $scope.slots = ContractConstants.slotList

    $scope.availableDesiredHour = ['08', '09', '10', '11', '13', '14', '15', '16']

    $scope.availableDesiredMinute = ['00', '15', '30', '45']

    $scope.selectedHourAndMinute = {
        selectedDesiredHour: $scope.availableDesiredHour[0],
        selectedDesiredMinute: $scope.availableDesiredMinute[0],
    }
    $scope.availableSlots = undefined

    $scope.createJira = createJira
    $scope.close = $uibModalInstance.dismiss

    $scope.activationErrorCode = null
    $scope.activationErrorNotified = false

    if (!$scope.contract.prm) {
        AlertManager.error('Le contrat ne possède pas de PRM !')
    }

    $scope.isMigratedLinky = () => PrmUtilsService.isMigratedLinky($scope.contract.prm)
    $scope.isLinky = () => PrmUtilsService.isLinky($scope.contract.prm.metter_kind)

    $scope.interMandatory = () => !$scope.isMigratedLinky() &&
        ((['MES_INTER', 'FIRST_MES', 'CDF_INTER'].includes($scope.chosen.subscription_type)) || ['COUP', 'LIMI'].includes($scope.contract.prm.powered_status))

    $scope.needInterWithoutAsking = () => $scope.interMandatory() || (!$scope.isMigratedLinky() && ($scope.differentCalendar() || $scope.differentPower())) ||
        ($scope.tariff && $scope.tariff.option && $scope.tariff.option.remote === false)

    $scope.needInter = function () {
        const toReturn = $scope.needInterWithoutAsking() || $scope.chosen.askInter || ($scope.tariff && !$scope.tariff.remote)
        if (!toReturn) {
            $scope.chosen.choosen_mes_type = 'NORMAL'
        }
        return toReturn || false
    }

    const isContactFilled = () => {
        return Object.values($scope.chosen.contact).every((field) => {
            return field !== ''
        })
    }

    $scope.interContactOk = function () {
        return !$scope.needInter() || $scope.chosen.overrideContact === false || ($scope.chosen.overrideContact && isContactFilled())
    }

    $scope.providerActionNeeded = () => $scope.activationTelesellerMode && ($scope.chosen.choosen_mes_type === 'TODAY')

    $scope.displayDateMessage = () => $scope.canSeeActivationMessages
    $scope.displayBypassInterMessage = () => $scope.chosen.subscription_type === 'MES' && $scope.chosen.askInter && $scope.chosen.readingMode === 'BYPASS'

    $scope.displayInterMessage = () => !$scope.contract.prm.communicating &&
        ['COUP', 'LIMI'].includes($scope.contract.prm.powered_status) && $scope.canSeeActivationMessages && $scope.contract.status === ContractConstants.status.PROC_MAN_MES_INTER
    $scope.displayActivationLinkyMessage = () => $scope.isMigratedLinky() &&
        $scope.contract.status === ContractConstants.status.INITIAL && $scope.canSeeActivationMessages
    $scope.displayMESLinky = () => !$scope.isMigratedLinky() && $scope.contract.prm.communicating &&
        ['COUP', 'LIMI'].includes($scope.contract.prm.powered_status) && $scope.contract.status === ContractConstants.status.INITIAL && $scope.canSeeActivationMessages
    $scope.displayFirstMES = () => $scope.contract.status === ContractConstants.status.PROC_MAN_1ER_MES && $scope.canSeeActivationMessages
    $scope.displayErrorMessage = () => ($scope.contract.subscription_type === 'MES' ||
        $scope.contract.subscription_type === 'CDF') && $scope.contract.status === ContractConstants.status.ERREUR_ACTIV_ENEDIS &&
        $scope.contract.activation_status === 'SGT4B5' && $scope.canSeeActivationMessages && !$scope.contract.prm.communicating && $scope.contract.prm.powered_status !== 'COUP'

    const minDate = moment().add(1, 'day').startOf('day')
    const maxDate = moment().add($scope.maxDays, 'day').startOf('day')

    $scope.initialDesiredMesDate = contract.desired_mes_date && moment(contract.desired_mes_date)

    $scope.isDifferentDMDFromInitial = () => {
        return $scope.initialDesiredMesDate && !$scope.initialDesiredMesDate.isSame($scope.chosen.desired_mes_date, 'day')
    }

    let desired_mes_date = moment((contract != null ? contract.desired_mes_date : undefined) || undefined)
    if (desired_mes_date.isBefore(minDate)) {
        desired_mes_date = moment(minDate)
    }

    if (desired_mes_date.isAfter(maxDate)) {
        desired_mes_date = moment(maxDate)
    }

    $scope.minDate = minDate.toDate()
    $scope.maxDate = maxDate.toDate()

    $scope.chosen = {
        askInter: !$scope.isC5,
        overrideContact: null,
        choosen_id_p_calendar: (contract.choosen_id_p_calendar || contract.id_p_calendar) === 'TEMPO' ? 'HPHC' : (contract.choosen_id_p_calendar || contract.id_p_calendar),
        choosen_max_power: contract.choosen_max_power || contract.max_power,
        choosen_temp_class_powers: contract.choosen_temp_class_powers || contract.prm.temp_class_powers,
        choosen_auto_prod_coupling: contract.choosen_auto_prod_coupling || contract.prm.auto_prod_coupling,
        choosen_auto_prod_devices_amount: contract.choosen_auto_prod_devices_amount || contract.prm.auto_prod_devices_amount,
        choosen_auto_prod_power: contract.choosen_auto_prod_power || contract.prm.auto_prod_power,
        choosen_mes_type: contract.choosen_mes_type || 'NORMAL',
        choosen_routing_tariff: contract.choosen_routing_tariff || contract.prm.routing_tariff,
        choosen_long_usage_context: contract.choosen_long_usage_context || contract.prm.long_usage_context,
        choosen_long_usage_package: contract.choosen_long_usage_package || contract.prm.long_usage_package,
        subscription_type: $scope.canModifySubscriptionType ? ((contract.subscription_type !== 'CDF') && contract.subscription_type) || null : contract.subscription_type,
        slot: $scope.isC5 ? $scope.slots[0].id : undefined,
        chosen_phase: contract.chosen_phase || PrmUtilsService.getPhasingForNbWires(contract.prm && contract.prm.nb_wires),
        date: desired_mes_date.toDate(),
        desired_mes_date: desired_mes_date.toDate(),
        desired_mes_hour: $scope.isC5 ? undefined : `${$scope.selectedHourAndMinute.selectedDesiredHour}:${$scope.selectedHourAndMinute.selectedDesiredMinute}:00`,
        enedisSlot: undefined,
        contact: {
            civ: 'M.',
            sn: '',
            givenname: '',
            phone: '',
        },
        readingMode: 'SEND',
        readings: {
            date: moment().toDate(),
            hp: undefined,
            hc: undefined,
            base: undefined,
        },
        slotApprovedByClient: true,
        bypassServiceOrder: contract.technical_status ? contract.technical_status === 9 : contract.status === 9,
    }

    $scope.choosenValidity = {}

    $scope.isFirstMES = () => $scope.chosen.subscription_type === 'FIRST_MES'

    $scope.warningLU = () => {
        return ($scope.chosen.choosen_routing_tariff === 'BTINFLU' && $scope.chosen.choosen_long_usage_context === null) ||
            (['SSCPT', 'PSC'].includes(contract.prm.metter_kind) && $scope.chosen.choosen_long_usage_package === null && $scope.chosen.subscription_type !== 'FIRST_MES')
    }

    const postComment = () => AdminComments.addComment({ object: contract.id, comment: $scope.message }).$promise.catch(ErrorCatcher)

    if (contract.lastReadings && (contract.lastReadings.length > 0)) {
        $scope.chosen.readings.date = moment(contract.lastReadings[0].end_date).toDate()
        _.forEach(contract.lastReadings, (r) => {
            $scope.chosen.readings[r.temp_class.toLowerCase()] = r.value
        })
    }

    $scope.updateSelectedDesiredHourAndMinute = () => {
        $scope.chosen.desired_mes_hour = `${$scope.selectedHourAndMinute.selectedDesiredHour}:${$scope.selectedHourAndMinute.selectedDesiredMinute}:00`
    }

    const computeUrgenceList = () => {
        if ($scope.chosen.subscription_type === 'FIRST_MES') {
            $scope.urgenceList = $scope.urgencesFirstMES
        } else if ($scope.chosen.subscription_type === 'CDF_INTER') {
            $scope.urgenceList = $scope.urgencesCDFInter
        } else if ($scope.isMigratedLinky()) {
            $scope.urgenceList = $scope.urgencesComLinky
        } else {
            $scope.urgenceList = $scope.urgences
        }
    }

    $scope.fetchPrices = () => {
        computeUrgenceList()
        $scope.computeTariff()
        if ($scope.displayBypassInterMessage()) {
            $scope.computeTariff('SPECIAL_REPORT')
        }
        if ($scope.displayInterMessage() || $scope.displayFirstMES()) {
            $scope.computeTariff('INTERVENTION_IN_VAIN')
            $scope.computeTariff('INTERVENTION_LATE_CANCELATION')
        }
    }

    $scope.translateValueLabel = ({ possibleValues, possibleRange, enedisValue }) => {
        if (possibleRange && typeof enedisValue === 'object') {
            return _.map(enedisValue, (value, key) => `${key}: ${value} ${possibleRange.unit}`).join(', ')
        }
        const found = _.find(possibleValues, { enedisValue })
        return found ? found.label : enedisValue
    }

    $scope.getItemMessage = (values, value) => {
        const found = _.find(values, { value })
        return found ? found.message : null
    }
    $scope.validateModificationValues = () => {
        const payload = _.assign({}, contract, $scope.chosen)
        return PrmValuesValidatorService.validate(payload, !!$scope.proMode).then((result) => {
            $scope.modificationValues = _.pickBy(result.toJSON(), (elem) => !elem.hidden || (elem.value && elem.enedisValue !== elem.value && elem.possibleValues && elem.possibleValues.length > 1))
            $scope.appendVoidFlexBox = Object.keys($scope.modificationValues).length % 3 === 2
            _.assign($scope.chosen, ..._.map(result.toJSON(), (values, field) => ({ [field]: values.value })))
            _.assign($scope.choosenValidity, ..._.map(result.toJSON(), (values, field) => ({ [field]: Boolean(values.hidden || (!values.isInvalid && values.value !== null)) })))
        })
        .catch(ErrorCatcher)
    }

    // COMPUTE TARIF
    $scope.computeTariff = function (type) {
        $scope.computing = true
        $scope.needInter()
        $scope.urgenceText = _.find($scope.urgenceList, { value: $scope.chosen.choosen_mes_type }).text
        if (($scope.chosen.readingMode !== 'OVERRIDE') && !$scope.chosen.askInter) {
            $scope.chosen.readingMode = $scope.needInter() ? 'BYPASS' : 'SEND'
        }
        const payload = {
            id_contract: $scope.contract.id,
            prestationType: type || ($scope.chosen.subscription_type || $scope.contract.subscription_type),
            choosen_mes_type: $scope.chosen.choosen_mes_type,
            choosen_max_power: $scope.chosen.choosen_max_power,
            choosen_temp_class_powers: $scope.chosen.choosen_temp_class_powers,
            choosen_auto_prod_coupling: $scope.chosen.choosen_auto_prod_coupling,
            choosen_auto_prod_devices_amount: $scope.chosen.choosen_auto_prod_devices_amount,
            choosen_auto_prod_power: $scope.chosen.choosen_auto_prod_power,
            choosen_id_p_calendar: $scope.chosen.choosen_id_p_calendar,
            choosen_routing_tariff: $scope.chosen.choosen_routing_tariff,
            chosen_phase: $scope.chosen.chosen_phase,
            specialReport: $scope.chosen.askInter,
            sendReadings: $scope.chosen.readingMode !== 'BYPASS',
        }
        return ApiUser.computeTariff({ pro: $scope.proMode || $scope.smallBusinessMode }, payload).$promise.then((tariffResult) => {
            if (['INTERVENTION_IN_VAIN', 'INTERVENTION_LATE_CANCELATION', 'SPECIAL_REPORT'].includes(type)) {
                $scope.prices[type] = tariffResult.toJSON()
            } else {
                $scope.tariff = tariffResult.toJSON()
            }
            if ($scope.tariff && !$scope.tariff.remote && $scope.chosen.subscription_type === 'CDF') {
                $scope.chosen.subscription_type = 'CDF_INTER'
            } else if ($scope.tariff && (!$scope.tariff.option || $scope.tariff.option.remote) && $scope.chosen.subscription_type === 'CDF_INTER') {
                $scope.chosen.subscription_type = 'CDF'
            }
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.computing = false
        })
    }

    $scope.valueChanged = () => {
        $scope.validateModificationValues().then(() => {
            if ($scope.isC5) { /* faire péter si on veut pricer du c2c4 */
                if ($scope.chosen.choosen_id_p_calendar && $scope.chosen.choosen_max_power && $scope.chosen.choosen_routing_tariff) {
                    $scope.fetchPrices()
                }
            }
        })
    }

    $scope.valueChanged()


    $scope.differentCalendar = () => $scope.chosen.choosen_id_p_calendar !== contract.prm.id_p_calendar

    $scope.differentPower = () => $scope.chosen.choosen_max_power !== contract.prm.max_power

    $scope.differentFTA = () => $scope.chosen.choosen_routing_tariff !== contract.prm.routing_tariff

    $scope.differentMesType = () => $scope.chosen.choosen_mes_type !== contract.choosen_mes_type

    $scope.differentContext = () => $scope.chosen.choosen_long_usage_context !== (contract.prm && contract.prm.long_usage_context)

    $scope.differentPackage = () => $scope.chosen.choosen_long_usage_package !== (contract.prm && contract.prm.long_usage_package)

    $scope.canLaunchActivation = () => !$scope.warningLU() && $scope.interContactOk() && Object.values($scope.choosenValidity).every((validity) => validity)

    $scope.canNotifyError = () => !!$scope.activationErrorCode

    $scope.format = (stringDate) => moment(stringDate, 'YYYY-MM-DD').format('DD/MM/YYYY')

    $scope.longFormat = (stringDate) => moment(stringDate, 'YYYY-MM-DD').format('DD MMMM YYYY')

    $scope.differentMonthes = (date1, date2) => moment(date1, 'YYYY-MM-DD').month() !== moment(date2, 'YYYY-MM-DD').month()

    $scope.isObjectField = (field, conf) => Boolean(typeof $scope.chosen[field] === 'object' && conf.possibleRange)

    const parseAvailableSlots = function (result) {
        $scope.days = []
        _.forEach(result, (r) => {
            const existing = _.find($scope.days, { date: r.date })
            if (existing) {
                existing.availableSlots.push(r.code)
            } else {
                $scope.days.push({ date: r.date, availableSlots: [r.code] })
            }
        })
    }


    const preparePayload = function () {
        const choosenSlot = Object.assign({}, _.pick($scope.chosen, [
            'choosen_id_p_calendar',
            'choosen_max_power',
            'choosen_temp_class_powers',
            'choosen_auto_prod_coupling',
            'choosen_auto_prod_devices_amount',
            'choosen_auto_prod_power',
            'choosen_mes_type',
            'choosen_long_usage_context',
            'choosen_long_usage_package',
            'choosen_routing_tariff',
            'chosen_phase',
            'bypassServiceOrder',
            'desired_mes_hour',
        ]))

        if ($scope.chosen.overrideContact) {
            choosenSlot.contact = $scope.chosen.contact
        }

        choosenSlot.desired_mes_date = moment($scope.chosen.desired_mes_date).format('YYYY-MM-DD')

        if ($scope.chosen.enedisSlot && ($scope.chosen.enedisSlot.slot !== 'RETRY')) {
            $scope.chosen.slot = $scope.chosen.enedisSlot.slot
            $scope.chosen.date = moment($scope.chosen.enedisSlot.date, 'YYYY-MM-DD').toDate()
        }
        if ($scope.needInter() || $scope.availableSlots) {
            choosenSlot.slot = $scope.chosen.slot
            choosenSlot.date = moment($scope.chosen.date).format('YYYY-MM-DD')
        }
        if ($scope.chosen.readingMode === 'BYPASS') {
            choosenSlot.bypassReadings = true
        } else if ($scope.chosen.readingMode === 'OVERRIDE') {
            choosenSlot.readings = angular.copy($scope.chosen.readings)
            choosenSlot.readings.date = moment(choosenSlot.readings.date).format('YYYY-MM-DD')
            if ($scope.contract.id_p_calendar === 'BASE') {
                delete choosenSlot.readings.hc
                delete choosenSlot.readings.hp
            } else {
                delete choosenSlot.readings.base
            }
        }
        choosenSlot.askInter = $scope.chosen.askInter
        choosenSlot.intervention_comment = $scope.chosen.intervention_comment
        choosenSlot.askedEarlySlot = !$scope.chosen.slotApprovedByClient
        choosenSlot.askedEarlySlotComment = $scope.chosen.au_comment || 'Non renseigné'
        return choosenSlot
    }

    const computeResultMessage = function (intervention, choosenSlot) {
        let message = 'Demande de '
        message += $filter('subType')($scope.chosen.subscription_type)
        message += ` effectuée par <b>${AuthService.getAuth().user}</b>, envoyée avec succès`
        if (intervention) {
            if (intervention.remote) {
                message += ', l\'intervention sera effectuée sans déplacement'
            } else {
                message += ', un technicien se présentera chez le client (présence du client obligatoire)'
            }
            message += ` le <b>${moment(intervention.date, 'YYYY-MM-DDZ').format('DD/MM/YYYY')}`
            if (intervention.begin) {
                message += ` entre ${intervention.begin}`
                message += ` et ${intervention.end}</b>`
            }
        }
        if (!intervention && choosenSlot.slot) {
            const delay = $scope.chosen.subscription_type === 'FIRST_MES' ? '10' : '2'
            if (choosenSlot.choosen_mes_type === 'NORMAL') {
                message += `<br><b>Attention</b> Le RDV choisi n'a pas été confirmé par Enedis. `
                message += `Enedis va donc prendre contact avec le client d'ici ${delay} jours ouvrés au soir pour programmer un autre rendez-vous.`
            } else {
                message += `<br><b>Attention</b> Le RDV choisi n'a pas été confirmé par Enedis.`
                message += `<br>Pour que la mise en service puisse avoir lieu d'ici ${delay} jours ouvrés un traitement immédiat par le service client Plüm énergie est nécessaire :`
                message += '<ul><li>tenter un transfert accompagné vers le service client Plüm</li>'
                message += `<li>en cas d'injoignabilité donner le numéro au client (${hotlineNumber}) et lui dire d'appeler au plus vite</li></ul>`
            }
            message += '<br><b>NB :</b> pour bien préciser la date butoir au client, '
            message += `compter ${delay} jours pleins à partir de demain, sans compter les samedis, dimanches et jours fériés.<br>`
        }
        if (choosenSlot.bypassReadings) {
            message += '<br>Relève non-envoyée'
        } else if (choosenSlot.readings) {
            message += '<br>Relève envoyée : '
            if (choosenSlot.readings.hp) {
                message += `HP : ${choosenSlot.readings.hp}, `
            }
            if (choosenSlot.readings.hc) {
                message += `HC : ${choosenSlot.readings.hc}, `
            }
            if (choosenSlot.readings.base) {
                message += `BASE : ${choosenSlot.readings.base}, `
            }
            message += ` en date du ${choosenSlot.readings.date}`
        }
        if ($scope.tariff) {
            message += `<br>Prestation facturée : ${$scope.tariff.total} €`
            if ($scope.tariff.alternativeTotal != null) {
                message += ` ou ${$scope.tariff.alternativeTotal} €`
            }
            if ($scope.tariff.option) {
                message += `<br>Prestation prévue : ${$scope.tariff.option.label}`
            }
        }
        if (choosenSlot.contact) {
            message += `<br>Contact : ${choosenSlot.contact.civ} `
            message += `${choosenSlot.contact.givenname} `
            message += choosenSlot.contact.sn
            message += `, tel : ${choosenSlot.contact.phone}`
        }
        if (choosenSlot.askInter && choosenSlot.bypassReadings && ($scope.chosen.subscription_type === 'MES')) {
            message += '<br><br>Si le déplacement est bien justifié, le supplément lié à l\'intervention du technicien (30,76€) ne sera pas facturé'
        }
        if (choosenSlot.intervention_comment) {
            message += `<br>Commentaire pour l'intervention : ${choosenSlot.intervention_comment} `
        }
        return message
    }

    const computeEstimationResultMessage = function (params) {
        let modifiedFields = ''
        let header = ''
        if (params.old.id_p_calendar !== params.new.id_p_calendar) {
            header += '<b>d’option tarifaire</b>'
            modifiedFields += `<br>Ancienne option tarifaire: <b>${params.old.id_p_calendar}</b>`
            modifiedFields += `<br>Nouvelle option tarifaire: <b>${params.new.id_p_calendar}</b>`
        }
        if (params.old.max_power !== params.new.max_power) {
            header += params.old.id_p_calendar !== params.new.id_p_calendar ? ' et <b>de puissance</b>' : '<b>de puissance</b>'
            modifiedFields += `<br>Ancienne puissance: <b>${params.old.max_power}</b>`
            modifiedFields += `<br>Nouvelle puissance: <b>${params.new.max_power}</b>`
        }
        let message = `${$scope.proMode ? 'Changement' : 'Régénération échéancier suite à un changement'} ${header}`
        message += modifiedFields

        return message
    }

    const computeEstimation = () => {
        const params = {
            old: {
                id_p_calendar: contract.id_p_calendar,
                max_power: contract.max_power,
            },
            new: {
                id_p_calendar: $scope.chosen.choosen_id_p_calendar,
                max_power: $scope.chosen.choosen_max_power,
            },
        }
        return ApiUser.amendmentEstimation({ idContract: $scope.contract.id }, params).$promise
        .then((result) => {
            if (result.success) {
                $scope.message = computeEstimationResultMessage(params)
                AlertManager.success(result.message)
                return postComment()
            }
        })
    }

    $scope.activate = function () {
        if (!$scope.canLaunchActivation() || $scope.activating === true) {
            return
        }

        $scope.activating = true
        const choosenSlot = preparePayload()
        let p = Promise.resolve()
        if ($scope.chosen.subscription_type !== $scope.contract.subscription_type) {
            p = DataAccess.changeContractSubType({ id_contract: $scope.contract.id }, { subscription_type: $scope.chosen.subscription_type }).$promise
        }
        return p.then(() => {
            $scope.contract.subscription_type = $scope.chosen.subscription_type
            return ApiUser.activateContract({ idAccount: contract.id_account, idContract: contract.id }, choosenSlot).$promise
            .then((result) => {
                if (result.success) {
                    $scope.availableSlots = undefined
                    $scope.resultOk = true
                    $scope.message = computeResultMessage(result.intervention, choosenSlot)
                    $scope.messageHtml = $sce.trustAsHtml($scope.message)
                    AlertManager.success('Contrat activé avec succès !')

                    return postComment()
                    .then(() => {
                        return computeEstimation()
                    })
                } else if (result.intervention_needed && result.timeTable) {
                    $scope.availableSlots = result.timeTable
                    $scope.chosen.enedisSlot = {
                        slot: $scope.availableSlots[0].code,
                        date: $scope.availableSlots[0].date,
                    }
                    parseAvailableSlots($scope.availableSlots)
                } else {
                    AlertManager.error('Message de retour mal formé')
                }
            })
            .catch((error) => {
                const msg = __guard__(error != null ? error.data : undefined, (x) => x.message) || 'Erreur inconnue'
                AlertManager.error(msg, 15000)
                $scope.activationErrorCode = __guard__(error != null ? error.data : undefined, (x1) => x1.sgeCode)
            })
            .finally(() => {
                $scope.activating = false
            })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.activating = false
        })
    }

    $scope.notifyError = function () {
        $scope.notifying = true
        return ApiUser.notifyActivationError({ idAccount: contract.id_account, idContract: contract.id }, { error_code: $scope.activationErrorCode }).$promise
        .then((result) => {
            $scope.activationErrorNotified = true
            return AlertManager.success('Le client a été notifié de l\'erreur') })
        .catch((error) => {
            const msg = __guard__(error != null ? error.data : undefined, (x) => x.message) || 'Erreur inconnue'
            AlertManager.error(msg, 15000)
        })
        .finally(() => {
            $scope.notifying = false
        })
    }


    // CR MODE
    $scope.sgeInter = {
        id_case: null,
        bypassServiceOrder: contract.technical_status ? contract.technical_status === 9 : contract.status === 9,
    }
    $scope.reporting = false
    $scope.canReportActivation = () => !!$scope.sgeInter.id_case

    $scope.reportActivation = function () {
        $scope.reporting = true
        return ApiUser.reportContractActivation({ idContract: contract.id }, $scope.sgeInter).$promise.then((result) => {
            $scope.message = `Demande effectuée directement dans SGE, numéro affaire ${$scope.sgeInter.id_case}`
            AlertManager.success(result.message)
            postComment()
            $scope.ok()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.reporting = false
        })
    }

    // generate
    $scope.openClientActivation = () => {
        $q.all({
            token: Tokens.createToken({ ttl: 1, unit: 'day' }, { type: 'ACTIVATION', id_account: $scope.contract.id_account, id_contract: $scope.contract.id }).$promise,
        }).then((result) => {
            const url = `${EnvUtils.frontUrl}/activation/?token=${result.token.tokenId}`
            window.open(url, '_blank')
        })
    }

    $scope.caracDeployed = $scope.differentPower() ||
        $scope.differentCalendar() ||
        $scope.differentFTA() ||
        ($scope.chosen.choosen_id_p_calendar === 'LU' && ($scope.differentContext() || $scope.differentPackage()))

    // CHECK IF CARAC HAS BEEN MODIFIED WITH VENDOR
    if ((contract.prm.id_p_calendar && contract.id_p_calendar !== contract.prm.id_p_calendar) || (contract.prm.max_power && contract.max_power !== contract.prm.max_power)) {
        $scope.vendorCaracModificationMessage = `Les caractéristiques ont été modifiées ${contract.vendor ? `lors de la vente avec <u>${contract.vendor.name}</u>` : `par le client`}, ` +
        `initialement <b>${contract.prm.id_p_calendar}/${contract.prm.max_power}kVA</b> => <b>${contract.id_p_calendar}/${contract.max_power}kVA</b>.`
    }

    $scope.isSubscriptionType = (t) => {
        let types = t
        if (!_.isArray(t)) {
            types = [t]
        }
        return $scope.chosen.subscription_type ? types.includes($scope.chosen.subscription_type) : types.includes($scope.contract.subscription_type)
    }

    // RETURN OK
    $scope.ok = function () {
        MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
        return $uibModalInstance.close($scope.message)
    }
    $uibModalInstance.dismiss = $scope.ok
})

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
